<template>
<div>
    <sidebar-item :link="{ name: 'FROTA', icon: 'fas fa-gas-pump text-info' }">
        <sidebar-item v-if="permissoes.carrosRead" :link="{ name: 'CARROS', path: '/carros', icon: 'fas fa-car'}" />
        <sidebar-item v-if="permissoes.motoristasRead" :link="{ name: 'MOTORISTAS', path: '/motoristas', icon: 'fas fa-user-tie' }" />
    </sidebar-item>
</div>
</template>

<script>
export default {
    name: 'SidebarFrota',
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
}
</script>

